import _documentCreateElement from "../internals/document-create-element";
var exports = {};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = _documentCreateElement;
var classList = documentCreateElement("span").classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
export default exports;